import { ConversationService } from '@forwardflow/services/ConversationService'
import { PaginationQueryParams } from '@forwardflow/types'
import { Lead } from '@forwardflow/services/LeadService'
import { useOrgSWR } from '@forwardflow/hooks'
import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'

export const useGetRecentConversations = (
   queryParams: PaginationQueryParams
) => {
   const fetcher = () => ConversationService.getRecentConversations(queryParams)

   // Create a stable cache key by serializing the queryParams object
   const cacheKey = [
      QUERY_KEYS.RECENT_CONVERSATIONS,
      JSON.stringify(queryParams),
   ]

   const {
      data: leads,
      error,
      isLoading,
      mutate,
      isValidating,
   } = useOrgSWR(cacheKey, fetcher, {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
   })

   return {
      leads: leads as Lead[],
      loading: isLoading,
      isFetching: isValidating,
      error: error?.message || null,
      hasMore: (leads || []).length === queryParams.limit,
      mutate,
   }
}
